import { OrderStatusEnum } from './order-status.enum';

export interface BadgeCfg {
  tuiStatus: 'neutral' | 'success' | 'error';
  key: string;
  cssClass?: string; 
}

export const ORDER_STATUS_BADGE: Record<OrderStatusEnum, BadgeCfg> = {
  [OrderStatusEnum.INITIALIZED]: {
    tuiStatus: 'neutral',
    key: 'service_manager.modal.initialized',
  },
  [OrderStatusEnum.PENDING]: {
    tuiStatus: 'neutral',
    key: 'service_manager.modal.pending',
    cssClass: 'custom_pending',
  },
  [OrderStatusEnum.CONFIRMED]: {
    tuiStatus: 'success',
    key: 'service_manager.modal.confirmed',
    cssClass: 'custom_confirmed',
  },
  [OrderStatusEnum.PICKING_UP]: {
    tuiStatus: 'success',
    key: 'service_manager.modal.picking_up',
    cssClass: 'custom_picking_up',
  },
  [OrderStatusEnum.IN_PROGRESS]: {
    tuiStatus: 'success',
    key: 'service_manager.modal.in_progress',
    cssClass: 'custom_picking_up',
  },
  [OrderStatusEnum.DELIVERING]: {
    tuiStatus: 'success',
    key: 'service_manager.modal.delivering',
    cssClass: 'custom_picking_up',
  },
  [OrderStatusEnum.FINISHED]: {
    tuiStatus: 'success',
    key: 'service_manager.modal.finished',
    cssClass: 'custom_finished',
  },
  [OrderStatusEnum.FAILED]: {
    tuiStatus: 'error',
    key: 'service_manager.modal.failed',
  },
  [OrderStatusEnum.CANCELLED_BY_CAFLER]: {
    tuiStatus: 'error',
    key: 'service_manager.modal.cancelled_by_cafler',
  },
  [OrderStatusEnum.CANCELLED_BY_CLIENT]: {
    tuiStatus: 'error',
    key: 'service_manager.modal.cancelled_by_client',
  },
  [OrderStatusEnum.CANCELLED]: {
    tuiStatus: 'error',
    key: 'service_manager.modal.cancelled',
  },
};
